import {
  RecurringLineItem,
  RecurringLineItemType
} from "@wingspanhq/wingspan-api-sdk";
import { FormDataLineItem } from "../components/InvoicesForm/LineItemsSection/types";
import { selectorLineItemsCreate } from "./selectorLineItemsCreate";

export const selectorRecurringLineItems = (
  formLineItems: FormDataLineItem[]
): RecurringLineItem[] =>
  selectorLineItemsCreate(formLineItems).map(lineItem => {
    const { lineItemType, splits, ...rest } = lineItem;

    return {
      ...rest,
      type: lineItemType as unknown as RecurringLineItemType
    };
  });
